import Constant from "@/common/constant/Constant";
import Utils from "@/common/utils/utils";

export const prepareParamsGetListFormInCorporation = (usage, affiliationOrganization) => {
    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey': 'usage#affiliationOrganization#affiliationField#createdAt'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${usage}#${affiliationOrganization}`
            }
        },

        IndexName: Constant.GSI.FORM_GSI_1
    };

    return params;
};

/**
 * Get expression form master list by project
 * @param {*} corporationId 
 * @param {*} projectId 
 * @returns expression
 */
export const getExpressionFormMasterListByProject = (corporationId, projectId) => {
    let expression = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        FilterExpression: `contains(#usingProjects, :usingProjects_contains) AND #type = :type`,

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey': 'usage#affiliationOrganization#affiliationField#createdAt',
            '#usingProjects': 'usingProjects',
            '#type': 'type'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: Constant.FORM_USAGE.FORM
            },
            ':sortKey': {
                S: `${Constant.FORM_USAGE.FORM}#${corporationId}`
            },
            ':usingProjects_contains': {
                S: projectId
            },
            ':type': {
                S: Constant.FORM_TYPE.FORM_MASTER
            }
        },

        IndexName: Constant.GSI.FORM_GSI_1
    };

    return expression;
};

/**
 * 
 * @param {*} usage 
 * @param {*} affiliationOrganization 
 * @param {*} fieldId 
 * @param {*} nextToken is 'all' query don't paginate
 * @returns 
 */
export const prepareParamsGetItemFieldListByFieldId = (
    usage,
    affiliationOrganization,
    fieldId,
    nextToken = 'all'
) => {
    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey': 'usage#affiliationOrganization#affiliationField#createdAt'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${usage}#${affiliationOrganization}#${fieldId}`
            }
        },

        IndexName: Constant.GSI.FORM_GSI_1
    };

    if (nextToken !== 'all') {
        params.Limit = Constant.ITEMS_PER_QUERY_LIMIT;
    }

    // query paginate
    if (!Utils.isEmptyObject(nextToken) && nextToken !== 'all' && nextToken !== null && nextToken !== '') {
        params.ExclusiveStartKey = nextToken;
    }

    return params;
};
export const prepareParamsGetItemFieldListQACategoryOptions = (corporationId) => {
    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey': 'usage#affiliationOrganization#affiliationField#createdAt',
            '#definition': 'definition'
        },
        FilterExpression: '#definition = :definition',
        ExpressionAttributeValues: {
            ':usage': {
                S: 'TAG'
            },
            ':sortKey': {
                S: `TAG#${corporationId}`
            },
            ':definition': {
                S: Constant.FORM_DEFINITION.SYSTEM
            }
        },

        IndexName: Constant.GSI.FORM_GSI_1
    };

    return params;
}

/**
 * prepareParamsGetListFormFieldByGSI1
 * @param {*} usage 
 * @param {*} affiliationOrganization 
 * @param {*} affiliationField 
 * @returns 
 */
export const prepareParamsGetListFormFieldByGSI1 = (usage, affiliationOrganization, affiliationField) => {
    if (!usage) return;
    let sortKey = `${usage}`;
    if (affiliationOrganization) {
        sortKey = `${sortKey}#${affiliationOrganization}`;
        if (affiliationField) {
            sortKey = `${sortKey}#${affiliationField}`;
        }
    }

    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey': 'usage#affiliationOrganization#affiliationField#createdAt'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: sortKey
            }
        },

        IndexName: Constant.GSI.FORM_GSI_1
    };

    return params;
}

export const prepareQueryGetUsingTicketOfForm = (usage, affiliationOrganization,affiliationField,ticketId,projectId) => {
    if (!usage) return;
    let sortKey = `${usage}`;
    if (affiliationOrganization) {
        sortKey = `${sortKey}#${affiliationOrganization}`;
        if (affiliationField) {
            sortKey = `${sortKey}#${affiliationField}`;
        }
    }

    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',
        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey': 'usage#affiliationOrganization#affiliationField#createdAt',
            '#usedProject': 'usedProject',
            '#usingTicket': 'usingTicket'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: sortKey
            },
            ':usedProject_eq': {
                S: projectId
            },
            ':usingTicket_eq': {
                S: ticketId
            }
        },
        FilterExpression: '#usedProject = :usedProject_eq AND #usingTicket = :usingTicket_eq',
        IndexName: Constant.GSI.FORM_GSI_1,
    };

    return params;
};


export const prepareParamsGetSystemFormsOfCorp = (corporationId) => {
    let params = {
        IndexName: Constant.GSI.FORM_GSI_1,

        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        FilterExpression: '#definition = :definition',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey': 'usage#affiliationOrganization#affiliationField#createdAt',
            '#definition': 'definition'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: 'FORM'
            },
            ':sortKey': {
                S: `FORM#${corporationId}`
            },
            ':definition': {
                S: Constant.FORM_DEFINITION.SYSTEM
            }
        }
    };


    return params;
}

export const prepareParamsGetFormField = (
    corporationId,
    projectId,
    usage = Constant.FORM_USAGE.FORM,
    type = Constant.FORM_TYPE.FORM_REQ,
    definition = Constant.FORM_DEFINITION.SYSTEM
) => {
    const params = {
        IndexName: Constant.GSI.FORM_GSI_1,

        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        FilterExpression:
            '#definition = :definition AND #affiliationProject = :affiliationProject AND #type = :type',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey': 'usage#affiliationOrganization#affiliationField#createdAt',
            '#definition': 'definition',
            '#affiliationProject': 'affiliationProject',
            '#type': 'type'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${usage}#${corporationId}`
            },
            ':affiliationProject': {
                S: projectId
            },
            ':definition': {
                S: definition
            },
            ':type': {
                S: type
            },
        }
    };

    return params;
};

export const prepareParamsGetSystemFieldOfCorp = (corporationId) => {
    let params = {
        IndexName: Constant.GSI.FORM_GSI_1,

        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        FilterExpression: '#definition = :definition',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey': 'usage#affiliationOrganization#affiliationField#createdAt',
            '#definition': 'definition'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: 'FIELD'
            },
            ':sortKey': {
                S: `FIELD#${corporationId}`
            },
            ':definition': {
                S: Constant.FORM_DEFINITION.SYSTEM
            }
        }
    };


    return params;
}
